module.exports = __webpack_public_path__ + "static/media/tick_inside.7c14117d.png";